var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.094,
    height: 14.396,
    viewBox: "0 0 16.094 14.396",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M439.14,601.984s4.514,3.292,5.67,4.141c1.352-1.856,8.328-11.415,8.328-11.415",
    transform: "translate(-438.256 -593.826)",
    fill: "none",
    stroke: "#06d2bd",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4wOTQiIGhlaWdodD0iMTQuMzk2IiB2aWV3Qm94PSIwIDAgMTYuMDk0IDE0LjM5NiI+CiAgPHBhdGggaWQ9IlBhdGhfMTA4MCIgZGF0YS1uYW1lPSJQYXRoIDEwODAiIGQ9Ik00MzkuMTQsNjAxLjk4NHM0LjUxNCwzLjI5Miw1LjY3LDQuMTQxYzEuMzUyLTEuODU2LDguMzI4LTExLjQxNSw4LjMyOC0xMS40MTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MzguMjU2IC01OTMuODI2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDZkMmJkIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };